import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Loader from "./Loader";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode, FilterOperator } from "primereact/api";

const RevisionTable = ({
  revision,
  loading,
  vencimientoBody,
  actionBodyTemplate,
  handleRowClick,
}) => {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [filters, setFilters] = useState(null);
  useEffect(() => {
    initFilters();
  }, []);
  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      nombre_producto: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    });
    setGlobalFilterValue("");
  };
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const renderHeader = () => {
    return (
      <div className="flex justify-content-between">
        <span className="p-input-icon-left" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
          <i className="pi pi-search" />
          <InputText
            value={globalFilterValue ? globalFilterValue.toUpperCase() : ""}
            onChange={(e) => onGlobalFilterChange(e)}
            placeholder="Buscar por Cliente..." 
          />
        </span>
        <h6 className="p-input-icon-left ml-2" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
          {revision?.length} cotizaciones
        </h6>
      </div>
    );
  };
  const header = renderHeader();
  return (
    <div className="col-12">
      <div className="card">

        <div className="col-12">
          {loading ? (
            <>
              <Loader></Loader>
            </>
          ) : (
            <>
            <DataTable
              value={revision}
              paginator
              rows={10}
              rowsPerPageOptions={[10, 20, 50, 100]}

              dataKey="id"
              filters={filters}
              filterDisplay="menu"
              loading={loading}
              emptyMessage="No se encontraron Cotizaciones."
              rowClassName="row-clickable"
              className="p-datatable-gridlines "
              onRowClick={(e) => handleRowClick(e.data)}
              header={header}
              globalFilterFields={["cliente.razonSocial"]}
              stripedRows="true"
              showGridlines
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
              currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} cotizaciones"
              scrollHeight="57vh"
              scrollable
            >
              <Column
                field="id"
                header="Cotización"
                style={{ minWidth: "7rem" }}
                body={(rowData) => (
                  <span>
                    {rowData.folio ? (
                      <><strong>Folio</strong> {rowData.folio} <br/>
                      <strong>ID</strong> {rowData.id}</>
                    ) : (
                      <><strong>ID</strong> {rowData.id}</>
                    )}
                  </span>
                )}
                sortable 
                sortField="id"
              />

              <Column
                field="cliente.razonSocial"
                header="Cliente"
                style={{ minWidth: "7rem" }}
                body={(rowData) => rowData.cliente.razonSocial}
                sortable
              />

              <Column
                field="desde"
                header="Desde"
                body={(rowData) => rowData.desde || "No tiene fecha"}
                sortable
              /> 

              <Column
                field="hasta"
                header="Hasta"
                body={(rowData) => rowData.hasta || "No tiene fecha"}
                sortable
              />
              <Column
                field="estado"
                header="Estado"
                style={{ minWidth: "7rem" }}
                body={(rowData) => rowData.estado || "Sin estado"}
                sortField="estado"
                sortable
              />
              <Column
                field="empresa"
                header="Empresa"
                filterMenuStyle={{ width: "14rem" }}
                style={{ minWidth: "7rem" }}
                body={(rowData) => rowData.empresa}
                sortable
                sortField="empresa"
              />
              
              <Column
                field="creadorNombre"
                header="Responsable"
                style={{ minWidth: "7rem" }}
                body={(rowData) => rowData.creadorNombre}
                sortable
                sortField="creadorNombre"
              />
              
              <Column
                field="Vencimiento"
                header="Vencimiento"
                style={{ minWidth: "7rem" }}
                body={vencimientoBody}
                sortable
                sortField="vencimiento"
              />

              <Column
                field="observacion"
                header="Motivo"
                style={{ minWidth: "7rem" }}
                body={(rowData) => rowData.observacion}
                sortable
                sortField="observacion"
              />



              <Column
                header="Acción"
                body={actionBodyTemplate}
                style={{ minWidth: "12rem", textAlign: "center" }}
              /> 
            </DataTable>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default RevisionTable;
